import React from 'react';
import styles from './LiveUnloadPlannerCard.module.css';

export const PLANNER_CARD_DEFAULT_HEADER_HINT =
  'Target = delivery time + unloading time + drive to port';

export function PlannerCardHeader({ status, badges = [], headerHint }) {
  const hint =
    headerHint === undefined || headerHint === null
      ? PLANNER_CARD_DEFAULT_HEADER_HINT
      : headerHint;

  return (
    <header className={styles.header}>
      <div className={styles.headerBadges}>
        {status ? <span className={styles.badgeDark}>{status}</span> : null}
        {/* {badges.map((b) => (
          <span key={b} className={styles.badge}>
            {b}
          </span>
        ))} */}
      </div>
      {hint !== '' ? <p className={styles.headerHint}>{hint}</p> : null}
    </header>
  );
}
